module.exports = __webpack_public_path__ + "media/images/flags/KI-1234e35f700633c1e1322b75bb76af5b.svg";